import { Component, OnInit } from '@angular/core';
import { ReportsService } from '../reports.service';
import { GlobalFunctionsService } from '../../common/functions/global-functions.service';
import { Unit } from '../../common/models/Unit.Model';

@Component({
  selector: 'app-rep-label',
  templateUrl: './rep-label.component.html',
  styleUrls: ['./rep-label.component.scss']
})
export class RepLabelComponent implements OnInit {

  public downloading: boolean = false;
  public working: boolean = false;

  // Manejo de Fechas
  public minDate: string;
  public maxDate: string;
  public today: string;
  public isValidRange: boolean = true;

  // Variable que recibirá el valor desde (returnValue)
  public datetype: number = 0;

  // Opciones mapeadas correctamente
  public dateTypeOptions = [
    { id: 0, name: 'Fecha de creación' },
    { id: 1, name: 'Fecha de Impresión' },
    { id: 2, name: 'Fecha de uso' }
  ];

  // Datos
  public unitList: Unit[] = [];
  public unitSelectedId: number = 0;

  constructor(
    private reportService: ReportsService,
    private globalFunctionService: GlobalFunctionsService
  ) {
    const dateNow = new Date();
    this.today = this.globalFunctionService.getStringDate(dateNow, false, 0);
    this.minDate = this.today;
    this.maxDate = this.today;
  }

  ngOnInit(): void {
    this.globalFunctionService.canOperate();
    this.globalFunctionService.hasFSBRPending();
    this.loadUserNodes();
  }

  private loadUserNodes(): void {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const org = user.Org || 1;
    const userId = user.Id || 0;

    this.reportService.getUserNodes(org, userId, "0").subscribe({
      next: (data: any[]) => {
        this.unitList = data.filter(u => u.UnitLevel === "Centro de Ventas");
      },
      error: () => this.globalFunctionService.messageToast('Error al cargar centros de ventas', 'warning')
    });
  }

  selectedUnitChange(unit: Unit): void {
    this.unitSelectedId = unit.UnitId;
  }

  unitCleared(): void {
    this.unitSelectedId = 0;
  }

  download(): void {
    if (!this.minDate || !this.maxDate) {
      this.globalFunctionService.messageToast('Debe seleccionar un rango de fechas.', 'warning');
      return;
    }

    this.downloading = true;
    this.reportService.downloadLabelExcelRep(this.unitSelectedId, this.datetype, this.minDate, this.maxDate)
      .subscribe({
        next: (resp: any) => {
          this.processDownload(resp);
        },
        error: (error) => {
          console.error(error);
          this.globalFunctionService.messageToast('Ocurrió un error al generar el archivo.', 'warning');
          this.downloading = false;
        },
        complete: () => {
          this.downloading = false;
        }
      });
  }

  private processDownload(resp: any): void {
    const blob = new Blob([resp], { type: resp.type });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.download = `Reporte etiquetas.xlsx`;
    anchor.href = url;
    anchor.click();
    window.URL.revokeObjectURL(url);
  }
}